import {OpenWebURL} from '../../utils/util';

import {
  Footer as DeereFooter,
  FooterLink,
  List,
  ListItem,
} from '@deere/ux.uxframe-react';
import './Footer.css';
import React from 'react';

const Footer = (props) => {
  return (
    <DeereFooter className="Footer loginFooter">
      {props.isShowList && (
        <List className="navfooter FooterList">
          <ListItem className="FooterListItem">
            <FooterLink
              className="FooterListItemFooterLink"
              onClick={(e) => {
                e.preventDefault();
                OpenWebURL(
                  'weburl',
                  'https://www.deere.com/en/privacy-and-data/'
                );
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy & Data
            </FooterLink>
          </ListItem>
          <ListItem className="FooterListItem">|</ListItem>
          <ListItem className="FooterListItem">
            <FooterLink
              className="FooterListItemFooterLink"
              onClick={(e) => {
                e.preventDefault();
                OpenWebURL(
                  'weburl',
                  'https://www.deere.com/en/privacy-and-data/terms/'
                );
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </FooterLink>
          </ListItem>
        </List>
      )}
    </DeereFooter>
  );
};

export default Footer;
